/**
 * Color constants used throughout the application
 */

export const COLORS = {
  // Cell comparison colors
  NEW: "#90ee90", // Light green for new items
  DELETED: "#ff6347", // Tomato red for deleted items
  MODIFIED: "#ffff00", // Yellow for modified items

  // UI colors
  EXCEL_GREEN: "#217346",
  EXCEL_GREEN_DARK: "#185a35",
  BACKGROUND: "#f8f8f8",
  WHITE: "#ffffff",
  TEXT_PRIMARY: "#333333",
  TEXT_ERROR: "#e53935",
  TEXT_WARNING: "#f57c00",
  TEXT_SUCCESS: "#388e3c",

  // Background colors for status messages
  ERROR_BG: "#ffebee",
  WARNING_BG: "#fff3e0",
  SUCCESS_BG: "#e8f5e9",

  // UI element colors
  BORDER: "rgba(0, 0, 0, 0.1)",
  SHADOW: "rgba(0, 0, 0, 0.2)",
  OVERLAY: "rgba(0, 0, 0, 0.5)",
  DISABLED: "#cccccc",
  DISABLED_DARK: "#bbbbbb",
} as const;

// Type for cell style colors
export type CellStyleColor = {
  bgColor: (typeof COLORS)[keyof typeof COLORS];
};
